var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.active
    ? _c(
        "div",
        {
          staticClass: "drive-matches",
          on: {
            mousedown: function ($event) {
              $event.stopPropagation()
            },
            click: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _c("div", { staticClass: "match-heading" }, [
            _c("span", { staticClass: "match-type" }, [
              _vm._v(_vm._s(_vm.type)),
            ]),
            _c("span", [_vm._v(_vm._s(_vm.source))]),
          ]),
          _vm._l(_vm.visibleMatches, function (match, index) {
            return _c("div", { key: index, staticClass: "match-item" }, [
              _c("span", { staticClass: "match-location" }, [
                _vm._v(_vm._s(match.locationLabel || "正文内容")),
              ]),
              _c(
                "p",
                { staticClass: "match-snippet" },
                [
                  _vm._l(_vm.parts(match), function (part, partIndex) {
                    return [
                      part.hit
                        ? _c("mark", { key: partIndex }, [
                            _vm._v(_vm._s(part.text)),
                          ])
                        : _c("span", { key: partIndex }, [
                            _vm._v(_vm._s(part.text)),
                          ]),
                    ]
                  }),
                ],
                2
              ),
            ])
          }),
          _vm.compact && _vm.matches.length > 1
            ? _c(
                "span",
                {
                  staticClass: "match-toggle",
                  attrs: { role: "button", tabindex: "0" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.toggle.apply(null, arguments)
                    },
                    keydown: [
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        $event.preventDefault()
                        return _vm.toggle.apply(null, arguments)
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "space", 32, $event.key, [
                            " ",
                            "Spacebar",
                          ])
                        )
                          return null
                        $event.preventDefault()
                        return _vm.toggle.apply(null, arguments)
                      },
                    ],
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.expanded
                        ? "收起"
                        : "展开其余" + (_vm.matches.length - 1) + "处匹配"
                    )
                  ),
                ]
              )
            : _vm._e(),
          _vm.row.matchDetailsUnavailable
            ? _c("span", { staticClass: "match-unavailable" }, [
                _vm._v("匹配摘要暂不可用，可先打开文件查看"),
              ])
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }